import React from "react";
import ButtonGroups, { BGItem } from "components/ButtonGroups";
import Tooltip from "components/Tooltip";
import { REFERENCE_UNITS } from "features/MappingEditor/consts";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { BPEStore } from "../ProductEditorStore";
import EPDGroup from "./EPDGroup";
import Button from "components/Button";
import Alert from "components/Alert";
import EPDSearchModal from "features/EPDSearchModal";
import SearchField from "../components/SearchField";

const EnvironmentalData = () => {
  const { t } = useTranslation();
  const [openEPDSearch, setOpenEPDSearch] = React.useState(false);

  const onChangeReferenceUnit = (value: BGItem | undefined) => {
    if (BPEStore.anyFactorAdded()) {
      BPEStore.resetFactors();
    }
    BPEStore.onChangeData("reference_unit", value);
  };

  const hasAnyEPDSelected = BPEStore.data.groups.some((item) =>
    item.epds.some((rec) => rec.epd?.id)
  );

  return (
    <div className="pb-6">
      <div className="text-base font-semibold mb-3 flex items-center">
        {t("productEditor.referenceUnitAndEnvironmentalData")}
        <Tooltip
          content={t("productEditor.enviromentalDataTooltip")}
          className="ml-1 text-gray-500"
        ></Tooltip>
      </div>
      <ButtonGroups
        items={REFERENCE_UNITS}
        onChange={onChangeReferenceUnit}
        current={REFERENCE_UNITS.find(
          (item) => item.id === BPEStore.data.reference_unit?.id
        )}
        containerClassName="w-full mb-3"
        label={t("components.reference_unit")}
        confirmTitle={t("productEditor.confirmModalTitle")}
        confirmButtonTitle={t("productEditor.changeReferenceUnit")}
        confirmDescriptionMesage={t("productEditor.changeReferenceUnitDesc")}
        hasConfirmation={BPEStore.anyFactorAdded()}
        helper={t("productEditor.referenceUnitHelper")}
        required
        optionClsssName="h-[36px]"
        size="middle"
      />
      {hasAnyEPDSelected ? (
        <div>
          {BPEStore.data.groups.map((_, index) => (
            <EPDGroup key={index} groupIndex={index} />
          ))}
          <div className="mb-8">
            <Button
              type="secondary"
              className="!text-base !font-medium"
              onClick={() => BPEStore.addEPDGroup()}
            >
              {t("productEditor.addDataset")}
            </Button>
            <Alert
              description={t("productEditor.addDatasetAlert")}
              className="!bg-white !border-none px-0 py-0 mt-3"
              type={BPEStore.saveValidationErrors ? "attention" : "info"}
            />
          </div>
        </div>
      ) : (
        <SearchField
          labelName="EPD"
          placeholder={t("productEditor.searchEPD")}
          containerClassName="mt-3"
          helper={t("productEditor.searchEPDHelper")}
          onClick={() => setOpenEPDSearch(true)}
          required
        />
      )}
      {openEPDSearch && (
        <EPDSearchModal
          open={openEPDSearch}
          close={() => setOpenEPDSearch(false)}
          datasetIndex={0}
          rowIndex={0}
        />
      )}
    </div>
  );
};

export default observer(EnvironmentalData);
